import { messages } from './BankStatementReportPopupContent.messages';
import { FileFormat } from './BankStatementReportPopupContent.types';

export const fileFormats = [
    {
        id: FileFormat.PDF,
        name: messages.pdf,
    },
    {
        id: FileFormat.CSV,
        name: messages.csv,
    },
];
